import {OfficeVisitSheet} from "../../api/Model";


export function filterOfficeVisitReport<Row, Visit>(
    sheet: OfficeVisitSheet<Row, Visit>,
    filterDate?: (date: string) => boolean,
    filterRow?: (row: Row) => boolean,
): OfficeVisitSheet<Row, Visit> {
    if (!filterDate && !filterRow) {
        return sheet;
    }

    const filterDateIndices = filterDate
        ? sheet.dates
            .map((date, index) => ({date, index}))
            .filter(({date}) => filterDate(date))
            .map(({index}) => index)
        : undefined;

    const filteredRows = filterRow
        ? sheet.rows.filter(row => filterRow(row.value))
        : sheet.rows;

    const filteredProjectedRows = filterDateIndices
        ? filteredRows.map(row => ({
            ...row,
            visits: filterDateIndices.map(index => row.visits[index])
        }))
        : filteredRows;

    return {
        dates: filterDateIndices
            ? filterDateIndices.map(index => sheet.dates[index])
            : sheet.dates,
        rows: filteredProjectedRows,
        length: filteredProjectedRows.length,
    };
}

export function ensureOfficeVisitReportIncludes<Row, Visit>(
    sheet: OfficeVisitSheet<Row, Visit>,
    rows: readonly Row[],
    rowKey: (row: Row) => string | number,
    defaultVisit: Visit
): OfficeVisitSheet<Row, Visit> {
    const existingRowValues = new Set(sheet.rows.map(row => rowKey(row.value)));
    const missingRows = rows.filter(row => !existingRowValues.has(rowKey(row)));

    if (missingRows.length === 0) {
        return sheet;
    }

    const newRows = missingRows.map(rowValue => ({
        value: rowValue,
        visits: sheet.dates.map(() => defaultVisit)
    }));

    const combinedRows = [...sheet.rows, ...newRows];

    return {
        dates: sheet.dates,
        rows: combinedRows,
        length: combinedRows.length,
    };
}